export default __webpack_public_path__ + "static/media/generator.7e58bb3c.png";